import { useSelector } from 'react-redux';

import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';
import Global from '../../store/global-selectors';

export const useEnableLtlRegistration = (): boolean => {
  const referralCode = useSelector(Global.selectSellerReferralCode);
  const hasInvalidCode = referralCode?.indexOf('ssg-') === 0;

  const ffValue = useFeatureFlag(FeatureFlagDeclarations.enableLtlRegistration);

  return !hasInvalidCode && ffValue;
};
